import { defineMessages } from "react-intl";

/** @deprecated use messages from extensions/ */
export default defineMessages({
  deactivateAppTitle: {
    id: "0d6W6p",
    defaultMessage: "Deactivate App",
    description: "dialog header",
  },
  deactivateApp: {
    id: "Xu4ech",
    defaultMessage:
      "Are you sure you want to disable this app? Your data will be kept until you reactivate the app.",
    description: "deactivate app",
  },
  deactivateNamedApp: {
    id: "O987DI",
    defaultMessage:
      "Are you sure you want to disable {name}? Your data will be kept until you reactivate the app.",
    description: "deactivate named app",
  },
  deactivateAppBillingInfo: {
    id: "94oZR0",
    defaultMessage: "You will be still billed for the app.",
    description: "deactivate app billing info",
  },
});
